import { ClickEvent, DataSource, Label, Snackbar, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { ModelRow, StringUtil } from "@mcleod/core";
import { OrderTabView } from "@mcleod/dispatch";
import { AutogenLayoutReplyResults } from "./autogen/AutogenLayoutReplyResults";

export class ReplyResults extends AutogenLayoutReplyResults {
    public tendersProcessedDataSource: DataSource;
    public resultData: ModelRow[];

    override onLoad(): void {
        this.replyResultsTable.selectedIndex = 0;
    }

    slideoutUnmountListener: () => void;

    replyResultsTableOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow: TableRow = event.getTableRow();
        const row = (event.target as TableRow).data;
        const purposeLabel = tableRow.findComponentById("purposeLabel") as Label;

        if (row.get("purpose_out") == "O") {
            purposeLabel.text = "Original";
        }
        else if (row.get("purpose_out") == "U") {
            purposeLabel.text = "Change";
        }
        else if (row.get("purpose_out") == "V") {
            purposeLabel.text = "Cancel";
        }

        const orderLabel = tableRow.findComponentById("orderLabel") as Label;
        const orderId: string = row.get("orderid_out");

        if (StringUtil.isEmptyString(orderId) || orderId == "undefined") {
            orderLabel.text = "N/A";
        }
    }

    replyResultsTableOnDoubleClick(event: ClickEvent) {
        const orderId = this.replyResultsTable.selectedRow.data.get("orderid_out");
        if (!StringUtil.isEmptyString(orderId) && orderId != "N/A" && orderId != "undefined") {
            OrderTabView.navigateTo({ key: orderId, newTab: true});
        } else {
            Snackbar.showSnackbar("Selected tender is not bound to an order.", { persist: true });
        }
    }
}
